import React from 'react'

export default function HighlightCardsWrapper ({ children, className = '' }) {
  return (
    <div className={'group mt-8 space-y-2 space-x-0 lg:flex lg:space-x-3 lg:space-y-0 xl:space-x-5 ' + className}>
      {children}
    </div>
  )
}
